import { forwardRef, useCallback } from 'react';

import { ButtonProps, Theme, Variant } from './Button.types';
import { StyledButton } from './Button.theme';

const ButtonComponent = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    id,
    ariaOwns,
    ariaHasPopup,
    ariaControls,
    className,
    style,
    children,
    onClick,
    callbackValue,
    disabled,
    href,
    startIcon,
    endIcon,
    type,
    fullWidth,
    onMouseDown,
    onTouchStart,
    onMouseUp,
    onMouseLeave,
    onTouchEnd,
    onMouseEnter,
    onMouseOver,
    variant,
    theme,
  } = props;

  const handleClick = useCallback(
    (e: any) => {
      const event = e;
      onClick?.(callbackValue, event);
    },
    [onClick, callbackValue]
  );

  return (
    <StyledButton
      id={id}
      ref={ref}
      aria-owns={ariaOwns}
      aria-controls={ariaControls}
      aria-haspopup={ariaHasPopup}
      buttonVariant={variant}
      buttonTheme={theme}
      buttonClassName={className}
      style={style}
      onClick={handleClick}
      disableRipple
      disableElevation
      disableFocusRipple
      disabled={disabled}
      href={href}
      startIcon={startIcon}
      endIcon={endIcon}
      type={type}
      fullWidth={fullWidth}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      onTouchEnd={onTouchEnd}
      onMouseEnter={onMouseEnter}
      onMouseOver={onMouseOver}
    >
      {children}
    </StyledButton>
  );
});

ButtonComponent.defaultProps = {
  className: undefined,
  style: undefined,
  theme: Theme.primary,
  variant: Variant.normal,
  onClick: () => {},
  callbackValue: undefined,
  disabled: false,
  href: undefined,
  startIcon: undefined,
  endIcon: undefined,
  type: 'button',
  fullWidth: false,
  ariaOwns: undefined,
  ariaHasPopup: undefined,
  ariaControls: undefined,
};

export { Theme as ButtonTheme, Variant as ButtonVariant } from './Button.types';
export default ButtonComponent;
